import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: RouteComponent,
  beforeLoad: () => {
    // Quem resolve a sessão é o guard das rotas autenticadas: se não houver,
    // ele mesmo manda para o login.
    throw redirect({ to: '/dashboard' });
  },
});

function RouteComponent() {
  return <></>;
}
